export const formatarCNPJ = (cnpj) => {
    // Verifica se o CNPJ é nulo, indefinido ou não tem a quantidade correta de caracteres
    if (!cnpj || cnpj.length !== 14) {
        return '';
    }

    // Formata o CNPJ
    return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12)}`;
};
